import React from "react";
import {
  makeStyles,
  tokens,
  Button,
  Card,
  Text,
} from "@fluentui/react-components";
import { Person24Regular } from "@fluentui/react-icons";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks";

const useStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  main: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    overflowY: "auto",
  },
  loginCard: {
    padding: tokens.spacingVerticalXXL,
    textAlign: "center",
    maxWidth: "400px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  loginIcon: {
    width: "64px",
    height: "64px",
    backgroundColor: tokens.colorBrandBackground2,
    borderRadius: tokens.borderRadiusCircular,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: tokens.spacingVerticalM,
  },
  loginDescription: {
    marginBottom: tokens.spacingVerticalL,
  },
  loginButton: {
    width: "100%",
  },
});

export const LoginPage: React.FC = () => {
  const styles = useStyles();
  const { isAuthenticated, login } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.page}>
      <main className={styles.main}>
        <Card className={styles.loginCard}>
          <div className={styles.loginIcon}>
            <Person24Regular />
          </div>
          <Text as="h2" size={500} weight="semibold" block>
            Sign in to continue
          </Text>
          <Text block className={styles.loginDescription}>
            Access your sales analytics data by signing in with your Microsoft
            account.
          </Text>
          <Button
            appearance="primary"
            onClick={login}
            className={styles.loginButton}
            size="large"
          >
            Sign In with Microsoft
          </Button>
        </Card>
      </main>
    </div>
  );
};
